module.exports = "//static.hsappstatic.net/unified-navigation-ui/static-1.19999/resources/fav-icon-red-big.ico"